import React, { useEffect, useState, useRef } from "react";
import "./MobileBottomNav.css";

import CartIcon from "../../../assets/icons/CartIcon";
import UserIcon from "../../../assets/icons/UserIcon";
import GridIcon from "../../../assets/icons/GridIcon";
import LogoIcon from "../../../assets/icons/LogoIcon";

// ⭐️ Notice we added isMobileMenuOpen to the props here!
const MobileBottomNav = ({ onNavigate, cartItemCount, currentPage, isMobileMenuOpen }) => {
  const [visible, setVisible] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.pageYOffset || window.scrollY;

      if (currentScrollY < 60) {
        setVisible(true);
        lastScrollY.current = currentScrollY;
        return;
      }

      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      if (currentScrollY >= maxScroll - 10) {
        setVisible(true);
        lastScrollY.current = currentScrollY;
        return;
      }

      if (currentScrollY > lastScrollY.current + 5) {
        setVisible(false); 
        lastScrollY.current = currentScrollY;
      } else if (currentScrollY < lastScrollY.current - 5) {
        setVisible(true);  
        lastScrollY.current = currentScrollY;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // ⭐️ THE FIX: If the mobile menu is open, strictly force this to be false (hidden)
  const shouldShow = visible && !isMobileMenuOpen;

  return (
    <div className={`mobile-bottom-nav ${shouldShow ? "show" : "hide"}`}>
      <button
        className={`nav-item ${currentPage === "home" ? "active" : ""}`}
        onClick={() => onNavigate("home")}
      >
        <LogoIcon />
        <span>Home</span>
      </button>

      <button
        className={`nav-item ${currentPage === "shop" ? "active" : ""}`}
        onClick={() => onNavigate("shop")}
      >
        <GridIcon />
        <span>Shop</span>
      </button>

      <button
        className={`nav-item ${currentPage === "cart" ? "active" : ""}`}
        onClick={() => onNavigate("cart")}
      >
        <div style={{ position: "relative" }}>
          <CartIcon itemCount={cartItemCount} />
        </div>
        <span>Cart</span>
      </button>

      <button
        className={`nav-item ${currentPage === "account" ? "active" : ""}`}
        onClick={() => onNavigate("account")}
      >
        <UserIcon />
        <span>Account</span>
      </button>
    </div>
  );
};

export default MobileBottomNav;